import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ValidationMessageComponent } from '../validation-message/validation-message.component';

@Component({
  selector: 'app-company-info-notice',
  imports: [ValidationMessageComponent, TranslateModule],
  templateUrl: './company-info-notice.component.html',
  styleUrl: './company-info-notice.component.css'
})
export class CompanyInfoNoticeComponent {
  @Input() companyInfoLoading = false;
  @Input() isCompanyInformationCompleted = true;
  @Output() onBtnClick = new EventEmitter<any>();

  handleBtnClick(event: any) {
    this.onBtnClick.emit(event);
  }
}
